import { render, staticRenderFns } from "./detail-form.vue?vue&type=template&id=e996a70a&scoped=true&"
import script from "./detail-form.vue?vue&type=script&lang=js&"
export * from "./detail-form.vue?vue&type=script&lang=js&"
import style0 from "./detail-form.vue?vue&type=style&index=0&id=e996a70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e996a70a",
  null
  
)

export default component.exports